export default function SciPy_Constants() {
  return (
    <div>
      <h1>SciPy Constants</h1>
    </div>
  );
}
